
 /*
  *****************************************************************************
  * WARNING: This file is automatically generated.
  * Do not edit this file manually.
  *****************************************************************************
  * 
  * The source file is located at:
  *   /codebuild/output/src994476363/src/vl-app/pages/automated-patient-dev.tsx
  */

import { createFileRoute } from '@tanstack/react-router';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Head from 'next/head';
import { AutomatedPatientParticipant, PenpalParticipantBridge } from '../lib/automatedParticipant';

const AutomatedPatientDev = () => {
  const { t } = useTranslation('common');
  useEffect(() => {
    const bridge = new PenpalParticipantBridge();
    const participant = new AutomatedPatientParticipant({ bridge });

    const handleInitError = (error: unknown) => {
      console.error('[AutomatedPatientDev] Failed to initialise automated participant', error);
    };

    const handleDisconnectError = (error: unknown) => {
      console.error('[AutomatedPatientDev] Failed to disconnect participant', error);
    };

    const cleanupBridge = () => {
      bridge.disconnect().catch(() => {});
    };

    participant.initialize().catch(handleInitError);

    return () => {
      participant.disconnect().catch(handleDisconnectError).finally(cleanupBridge);
    };
  }, []);

  return (
    <Head>
      <title>{t('Automated Patient')}</title>
      <style>{`
        body {
          margin: 0;
          padding: 0;
          width: 0;
          height: 0;
          overflow: hidden;
          visibility: hidden;
          opacity: 0;
          position: absolute;
          top: -9999px;
          left: -9999px;
        }
      `}</style>
    </Head>
  );
};

export default AutomatedPatientDev;
export const Route = createFileRoute('/automated-patient-dev')({ component: AutomatedPatientDev });
